import { render, staticRenderFns } from "./MyJourneyChart.vue?vue&type=template&id=f324bb40"
import script from "./MyJourneyChart.vue?vue&type=script&lang=js"
export * from "./MyJourneyChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports